import { useCallback, useState } from 'react';
import { SearchFormValues } from '@/features/ban-hang/bao-cao-ban-hang/bao-cao-tinh-trang-don-hang/schema';
import { useAuth } from '@/contexts/auth-context';
import api from '@/lib/api';

export const useBaoCaoTinhTrangDonHangBan = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { entity } = useAuth();

  const submitBaoCaoTinhTrangDonHangBan = useCallback(
    async (data: SearchFormValues): Promise<any> => {
      if (!entity?.slug) throw new Error('Entity not found');

      setIsLoading(true);
      try {
        const response = await api.post(
          `/entities/${entity.slug}/erp/ban-hang/bao-cao-ban-hang/bao-cao-tinh-trang-don-hang/`,
          data
        );
        return response.data;
      } catch (error) {
        console.error('Error submitting purchase report:', error);
        throw error;
      } finally {
        setIsLoading(false);
      }
    },
    [entity?.slug]
  ); // nhớ đưa slug vào dependency

  return {
    isLoading,
    submitBaoCaoTinhTrangDonHangBan
  };
};
